import { frontendURL } from '../../../../helper/URLHelper';

// Canned responses now live under Automations > Internal; keep old links working.
const redirect = to => ({ name: 'automations_canned', params: to.params });

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/canned-response'),
      redirect,
    },
    {
      path: frontendURL('accounts/:accountId/settings/canned-response/list'),
      redirect,
    },
  ],
};
